export default __webpack_public_path__ + "static/media/reduxx.a000f7cf.png";